export default __webpack_public_path__ + "static/media/img104.d30149ed.png";